const calcAverage = (item) => {
  const sum = item.reduce((a, b) => parseInt(a, 10) + parseInt(b, 10), 0);
  const avg = sum / item.length || 0;
  return { sum, avg: parseFloat(avg) };
};

export default calcAverage;
